import React, { Component } from 'react'
import Helmet from 'react-helmet'
import './home.sass'
import Link from 'gatsby-link'
import Slideshow from '../components/slideshow'

export default class IndexPage extends Component {
  componentDidMount() {
    if (window) {
      window.dispatchEvent(new Event('scroll'))
    }
  }

  render() {
    const { data } = this.props

    return (
      <div className="pb-4">
        <Helmet>
          <title>{data.site.siteMetadata.title}</title>
        </Helmet>

        <div className="wrap-narrower">
          <Slideshow
            images={data.allDatoCmsHomePage.edges[0].node.galleriaImmagini}
          />
        </div>

        <div className="wrap-narrower mt-4">
          <h2
            className="Progetto__Abstract text-primary"
            dangerouslySetInnerHTML={{
              __html: data.allDatoCmsHomePage.edges[0].node.testo,
            }}
          />

          <Link to="/progetto" className="text-bold-italic">
            Continua a leggere
          </Link>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  fragment FluidImage on DatoCmsAsset {
    url
    fluid(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }) {
      base64
      aspectRatio
      src
      srcSet
      sizes
    }
  }

  query Homepage {
    site {
      siteMetadata {
        title
      }
    }
    allDatoCmsHomePage {
      edges {
        node {
          testo
          galleriaImmagini {
            didascalia
            immagine {
              fixed(height: 400) {
                base64
                aspectRatio
                width
                height
                src
                srcSet
              }
              ...FluidImage
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js